import React, { useRef } from 'react';
import { gsap } from 'gsap';
import { useGSAP } from '@gsap/react';

const HandStory: React.FC = () => {
  const container = useRef<HTMLDivElement>(null);
  const handRef = useRef<HTMLDivElement>(null);
  const textRef = useRef<HTMLHeadingElement>(null);

  useGSAP(() => {
    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: container.current,
        start: "top 80%",
        end: "bottom 20%",
        scrub: 1,
      }
    });

    tl.from(handRef.current, {
      y: 200,
      rotation: -10,
      opacity: 0,
      ease: "power2.out"
    })
    .from(textRef.current, {
        scale: 0.95,
        opacity: 0,
        y: 40,
        ease: "power2.out"
    }, "-=0.5");
  }, { scope: container });

  return (
    <section ref={container} className="py-20 md:py-32 bg-[#F2E9D8] flex flex-col items-center justify-center relative overflow-hidden px-6">
        <div className="absolute inset-0 pointer-events-none opacity-[0.02] flex items-center justify-center">
             <span className="font-display text-[70vw] font-black leading-none text-[#1A3C28]">G</span>
        </div>

        <div className="relative w-full max-w-4xl flex flex-col items-center justify-center">
            <div className="relative w-56 h-20 md:w-80 md:h-28 bg-[#1A3C28] rounded-[100%] shadow-[inset_0_15px_30px_rgba(0,0,0,0.8)] border-2 border-white/5">
                 <div className="absolute inset-0 bg-gradient-to-t from-[#E05A38]/10 to-transparent rounded-full animate-pulse"></div>
            </div>
            
            <div ref={handRef} className="z-20 -mt-16 md:-mt-20 relative flex justify-center">
                <div className="relative group cursor-pointer">
                     <div className="w-12 h-32 md:w-16 md:h-44 bg-[#E8BEAC] rounded-b-full shadow-2xl transform rotate-3"></div>
                     <div className="absolute -top-12 md:-top-20 left-1/2 -translate-x-1/2 w-40 md:w-52 rotate-[-5deg] group-hover:rotate-0 transition-all duration-700">
                         <img 
                            src="https://images.unsplash.com/photo-1576458088443-04a19bb13da6?q=80&w=600&auto=format&fit=crop" 
                            className="w-full rounded-2xl md:rounded-3xl shadow-[0_20px_40px_rgba(0,0,0,0.4)] border-4 border-white" 
                            alt="Story slice" 
                         />
                     </div>
                </div>
            </div>

            <div className="mt-12 w-full text-center z-30">
                <h2 ref={textRef} className="font-display text-[15vw] md:text-[12vw] font-black uppercase text-[#1A3C28] leading-[0.7] tracking-tighter">
                    GUS<span className="text-[#E05A38]">TO</span>
                </h2>
                <div className="bg-[#1A3C28] text-white inline-flex items-center gap-4 px-8 md:px-10 py-3 md:py-4 rounded-full font-black uppercase tracking-[0.3em] text-[10px] mt-10 shadow-xl hover:bg-[#E05A38] transition-colors cursor-pointer group">
                    Explore Studio
                    <svg className="group-hover:translate-x-2 transition-transform" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3"><path d="M5 12h14m-7-7l7 7-7 7"/></svg>
                </div>
            </div>
        </div>
    </section>
  );
};

export default HandStory;